import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./DoctorProfile.scss";

import HERO_IMG from "../../../Assets/doctorprofileimg.png";
import ABOUT_IMG from "../../../Assets/dcprofilescend.png";

import { FaStar } from "react-icons/fa";
import { FiClock } from "react-icons/fi";
import { HiUserGroup } from "react-icons/hi";

export default function DoctorProfile() {

  const navigate = useNavigate();

  const [activePill, setActivePill] = useState(1);

  const [activeCard, setActiveCard] = useState(1);

  return (

    <div className="dpPage">

      {/* HERO */}

      <section className=" container dpHero">

        <div className="dpHeroLeft">

          <h1 className="dpName">
            Dr. Ranjana Mukherjee, MD
          </h1>

          <p className="dpRole">
            Trusted General Physician
          </p>

          <p className="dpDesc">

            Compassionate and dedicated doctor with over
            10 years of experience in providing high-quality
            patient-centered care.

          </p>

          <div className="dpBtns">

            <button

              className="dpPrimary"

              onClick={() => navigate("/appointment")}

            >

              Book Appointment

            </button>

            <button

              className="dpSecondary"

              onClick={() => navigate("/contact")}

            >

              Contact Me

            </button>

          </div>

          <div className="dpReview">

            <div className="dpRating">

              <span>
                4.9
              </span>

              <div className="dpStars">

                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />

              </div>

              <span>
                (120 Reviews)
              </span>

            </div>

            <div className="dpMeta">

              <div>

                <FiClock />

                <span>
                  1 Year Experience
                </span>

              </div>

              <div>

                <HiUserGroup />

                <span>
                  2500+ Patients Treated
                </span>

              </div>

            </div>

          </div>

        </div>

        <div className="dpHeroRight">

          <img src={HERO_IMG} alt="doctor" />

        </div>

      </section>

      {/* ABOUT */}

      <section className="container dpAbout">

        <div className="dpAboutLeft">

          <img src={ABOUT_IMG} alt="about" />

        </div>

        <div className="dpAboutRight">

          <h2>
            About
          </h2>

          <h3 className="dpTag">

            Caring for Your Health with
            Expertise and Compassion

          </h3>

          <p>

            Dr. Ranjana Mukherjee is a dedicated and compassionate General Physician with over 10 years of clinical experience caring for patients across all age groups. She believes in a patient-first approach, taking time to listen, understand concerns, and provide clear, practical guidance at every stage of care.

          </p>

          <p>

          Her clinical practice focuses on preventive healthcare, chronic disease management, and early diagnosis, helping patients make informed decisions about their health. Dr. Mehta is known for her calm, empathetic communication style and her commitment to delivering evidence-based treatment tailored to each individual’s needs.

          </p>
          <p>She completed her MD in Internal Medicine from a leading medical institution in India and has worked with reputed multi-specialty hospitals. Her goal is to make healthcare accessible, transparent, and reassuring, ensuring patients feel confident and supported throughout their treatment journey.</p>

          <div className="dpPills">

            <div

              onClick={() => setActivePill(0)}

              className={
                activePill === 0
                  ? "pill active"
                  : "pill"
              }

            >

              Personalized Treatment

            </div>

            <div

              onClick={() => setActivePill(1)}

              className={
                activePill === 1
                  ? "pill active"
                  : "pill"
              }

            >

              Routine Check-Up

            </div>

            <div

              onClick={() => setActivePill(2)}

              className={
                activePill === 2
                  ? "pill active"
                  : "pill"
              }

            >

              Preventive Care

            </div>

          </div>

        </div>

      </section>

      {/* SPECIALITY */}

      <section className="dpBottom">

        <div className="dpLeft">

          <h2>
            Speciality
          </h2>

          <p className="dpSub">

            Comprehensive Medical Services
            for All Ages

          </p>

          <div className="dpCards">

            <div

              onMouseEnter={() => setActiveCard(0)}

              className={
                activeCard === 0
                  ? "dpCard active"
                  : "dpCard"
              }

            >

              <h4>
                General Check Ups
              </h4>

              <p>

                Routine health check-ups to
                monitor overall health.

              </p>

            </div>

            <div

              onMouseEnter={() => setActiveCard(1)}

              className={
                activeCard === 1
                  ? "dpCard active"
                  : "dpCard"
              }

            >

              <h4>
                Chronic Disease Management
              </h4>

              <p>

                Ongoing care to manage
                long-term conditions.

              </p>

            </div>

            <div

              onMouseEnter={() => setActiveCard(2)}

              className={
                activeCard === 2
                  ? "dpCard active"
                  : "dpCard"
              }

            >

              <h4>
                Preventive Care
              </h4>

              <p>

                Wellness routines to
                catch issues early.

              </p>

            </div>

          </div>

        </div>

        {/* APPOINTMENT */}

        <div className="dpRight">

          <div className="dpAppointment">

            <h3>
              Schedule an Appointment
            </h3>

            <select>

              <option>
                Tue Apr 29
              </option>

            </select>

            <select>

              <option>
                11:00 AM - 11:30
              </option>

            </select>

            <select>

              <option>
                None
              </option>

            </select>

            <input
              placeholder="+91 978652341"
            />

            <button>

              Confirm Appointment

            </button>

          </div>

        </div>

      </section>

    </div>

  );

}
